// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staking-stakes__header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.staking-stakes__export-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);
  color: #166534;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, box-shadow 0.2s;
}

.staking-stakes__export-btn:hover:not(:disabled) {
  background: #dcfce7;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.staking-stakes__export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.staking-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted, #64748b);
  flex: 0 1 120px;
}

.staking-page-limit__select {
  max-width: none;
  margin: 0;
  min-width: 100px;
}

/* —— User Stakes: View button (teal / green theme) —— */
.staking-stakes__view-btn {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.4rem 0.85rem;
  border-radius: 8px;
  border: 1px solid rgba(15, 118, 110, 0.45);
  background: linear-gradient(180deg, #fff 0%, #f0fdfa 100%);
  color: #0f766e;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.12);
  transition: background 0.2s, box-shadow 0.2s, border-color 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.staking-stakes__view-btn:hover:not(:disabled) {
  background: #ccfbf1;
  border-color: #0d9488;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.2);
}

.staking-stakes__view-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.staking-stakes__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.staking-stakes__payout-actions {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  align-items: stretch;
  width: 100%;
}

.staking-stakes__payout-btn--plan {
  font-size: 0.72rem;
}

.staking-stakes__payout-badge {
  display: inline-block;
  padding: 0.25rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
}

.staking-stakes__payout-badge--active {
  background: #dcfce7;
  color: #166534;
}

.staking-stakes__payout-badge--inactive {
  background: #fef2f2;
  color: #b91c1c;
}

.staking-stakes__payout-btn {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  transition: background 0.2s, border-color 0.2s;
}

.staking-stakes__payout-btn--on {
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: #f0fdf4;
  color: #166534;
}

.staking-stakes__payout-btn--on:hover:not(:disabled) {
  background: #dcfce7;
}

.staking-stakes__payout-btn--off {
  border: 1px solid rgba(185, 28, 28, 0.35);
  background: #fef2f2;
  color: #b91c1c;
}

.staking-stakes__payout-btn--off:hover:not(:disabled) {
  background: #fee2e2;
}

.staking-stakes__payout-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.staking-stakes__cancel-btn {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid rgba(154, 52, 18, 0.4);
  background: #fff7ed;
  color: #9a3412;
  transition: background 0.2s, border-color 0.2s;
}

.staking-stakes__cancel-btn:hover:not(:disabled) {
  background: #ffedd5;
  border-color: #ea580c;
}

.staking-stakes__cancel-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.staking-stakes__edit-btn {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid rgba(15, 118, 110, 0.45);
  background: linear-gradient(180deg, #fff 0%, #f0fdfa 100%);
  color: #0f766e;
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.staking-stakes__edit-btn:hover:not(:disabled) {
  background: #ccfbf1;
  border-color: #0d9488;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.15);
}

.staking-stakes__edit-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.staking-stakes__edit-btn--submit {
  padding: 0.55rem 1.25rem;
  font-size: 0.88rem;
  border: none;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);
}

.staking-stakes__edit-btn--submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
  border-color: transparent;
  opacity: 0.95;
}

/* —— Edit subscription modal —— */
.staking-edit-modal {
  background: #fff;
  border-radius: 18px;
  max-width: 520px;
  width: 100%;
  max-height: min(92vh, calc(100dvh - 2rem));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(15, 118, 110, 0.15);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.staking-edit-modal__form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.staking-edit-modal__head {
  padding: 1.25rem 1.35rem 1rem;
  background: linear-gradient(125deg, #0f766e 0%, #0d9488 42%, #0f4c46 100%);
  color: #fff;
  flex-shrink: 0;
}

.staking-edit-modal__head h2 {
  margin: 0 0 0.35rem;
  font-size: 1.15rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.02em;
}

.staking-edit-modal__head p {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.45;
}

.staking-edit-modal__hint {
  margin: 0.5rem 0 0 !important;
  font-size: 0.75rem !important;
  color: rgba(255, 255, 255, 0.72) !important;
  font-style: italic;
}

.staking-edit-modal__body {
  padding: 1.15rem 1.35rem;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background: linear-gradient(180deg, #ecfdf5 0%, #f8fafc 28%, #f8fafc 100%);
}

.staking-edit-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

.staking-edit-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.staking-edit-field--full {
  grid-column: 1 / -1;
}

.staking-edit-field span {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #0f766e;
}

.staking-edit-field input,
.staking-edit-field select,
.staking-edit-field textarea {
  width: 100%;
  padding: 0.55rem 0.65rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.88rem;
  font-family: inherit;
  color: #0f172a;
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.staking-edit-field input:focus,
.staking-edit-field select:focus,
.staking-edit-field textarea:focus {
  outline: none;
  border-color: #0f766e;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.12);
}

.staking-edit-field--readonly span {
  color: #94a3b8;
}

.staking-edit-field--readonly input:disabled,
.staking-edit-field--readonly select:disabled,
.staking-edit-field--readonly textarea:disabled {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
  cursor: not-allowed;
  opacity: 1;
}

.staking-edit-field textarea {
  resize: vertical;
  min-height: 4.5rem;
}

.staking-edit-modal__id {
  margin: 0.85rem 0 0;
  font-size: 0.72rem;
  color: #64748b;
}

.staking-edit-modal__id code {
  font-size: 0.7rem;
  word-break: break-all;
  color: #334155;
}

.staking-edit-modal__error {
  margin: 0.75rem 0 0;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
  font-size: 0.85rem;
}

.staking-edit-modal__foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.35rem 1.25rem;
  flex-shrink: 0;
  border-top: 1px solid #d1fae5;
  background: #fff;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.04);
}

.staking-edit-modal__foot .staking-payout-btn-close:hover:not(:disabled) {
  background: #f0fdfa;
  border-color: #99f6e4;
  color: #0f766e;
}

@media (max-width: 480px) {
  .staking-edit-form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .staking-payout-overlay {
    align-items: flex-start;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.75rem;
  }

  .staking-edit-modal {
    max-height: none;
    margin: auto 0;
    flex-shrink: 0;
  }
}

/* —— Cancel plan confirm / success —— */
.staking-cancel-modal {
  background: #fff;
  border-radius: 16px;
  max-width: 440px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.35);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.staking-cancel-modal__head {
  padding: 1.25rem 1.35rem 1rem;
  background: linear-gradient(125deg, #9a3412 0%, #c2410c 55%, #7c2d12 100%);
  color: #fff;
}

.staking-cancel-modal__head h2 {
  margin: 0 0 0.35rem;
  font-size: 1.15rem;
  font-weight: 800;
  color: #fff;
}

.staking-cancel-modal__head p {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.45;
}

.staking-cancel-modal__body {
  padding: 1.15rem 1.35rem;
}

.staking-cancel-modal__summary {
  margin: 0 0 1rem;
  padding: 0.75rem 0.9rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #334155;
}

.staking-cancel-modal__summary strong {
  color: #0f172a;
}

.staking-cancel-modal__warn {
  margin: 0;
  font-size: 0.82rem;
  color: #b45309;
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  line-height: 1.45;
}

.staking-cancel-modal__foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0 1.35rem 1.25rem;
}

.staking-cancel-success__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
  margin: 0 0 1rem;
}

.staking-cancel-success__item {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
}

.staking-cancel-success__item dt {
  margin: 0 0 0.2rem;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #166534;
}

.staking-cancel-success__item dd {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: #14532d;
  word-break: break-word;
}

.staking-cancel-success__item--refund {
  grid-column: 1 / -1;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: #6ee7b7;
}

.staking-cancel-success__item--refund dd {
  font-size: 1.05rem;
  color: #047857;
}

/* —— Premium Payout history modal —— */
.staking-payout-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  backdrop-filter: blur(5px);
}

.staking-payout-modal {
  background: #fff;
  border-radius: 18px;
  max-width: 680px;
  width: 100%;
  max-height: 92vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(15, 118, 110, 0.15);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.staking-payout-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.35rem 1.5rem 1.2rem;
  background: linear-gradient(125deg, #0f766e 0%, #0d9488 42%, #0f4c46 100%);
  color: #fff;
  gap: 1rem;
}

.staking-payout-head-eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.88;
}

.staking-payout-modal__head h2 {
  margin: 0 0 0.25rem;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #fff;
}

.staking-payout-head-sub {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.4;
  max-width: 28rem;
}

.staking-payout-modal__close {
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: background 0.2s;
}

.staking-payout-modal__close:hover {
  background: rgba(255, 255, 255, 0.22);
}

.staking-payout-modal__body {
  min-height: 0;
  flex: 1 1;
  overflow-y: auto;
}

.staking-payout-modal__body--premium {
  padding: 1.5rem 1.5rem 1.25rem;
  background: linear-gradient(180deg, #ecfdf5 0%, #f8fafc 32%, #f8fafc 100%);
}

.staking-payout-loading {
  text-align: center;
  padding: 2.5rem 1.5rem;
  color: #64748b;
  font-size: 0.92rem;
}

.staking-payout-loading__ring {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 3px solid #ccfbf1;
  border-top-color: #0f766e;
  border-radius: 50%;
  animation: staking-payout-spin 0.7s linear infinite;
  margin-bottom: 0.75rem;
  vertical-align: middle;
}

@keyframes staking-payout-spin {
  to {
    transform: rotate(360deg);
  }
}

.staking-payout-alert {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  line-height: 1.45;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

/* Hero */
.staking-payout-hero {
  background: #fff;
  border-radius: 14px;
  padding: 1.2rem 1.35rem;
  margin-bottom: 1rem;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(15, 118, 110, 0.08);
}

.staking-payout-hero__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.staking-payout-hero__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #64748b;
}

.staking-payout-hero__title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.03em;
}

.staking-payout-hero__sub {
  font-weight: 500;
  color: #64748b;
  font-size: 0.9rem;
}

.staking-payout-hero__wallets {
  margin: 0.85rem 0 0;
  font-size: 0.86rem;
  color: #475569;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.staking-payout-hero__wallets i {
  color: #0f766e;
  width: 1.1rem;
  text-align: center;
}

.staking-payout-hero__arrow {
  color: #94a3b8;
  font-weight: 600;
  padding: 0 0.1rem;
}

.staking-payout-notes-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9rem 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.staking-payout-notes-card__title {
  margin: 0 0 0.5rem;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.staking-payout-notes-card__title i {
  color: #0f766e;
}

.staking-payout-notes-card__text {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.5;
  color: #334155;
  white-space: pre-wrap;
  word-break: break-word;
}

.staking-payout-status-pill {
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  border: 1px solid transparent;
  flex-shrink: 0;
}

.staking-payout-status-pill--on {
  background: #d1fae5;
  color: #047857;
  border-color: #a7f3d0;
}

.staking-payout-status-pill--off {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

.staking-payout-status-pill--done {
  background: #ccfbf1;
  color: #0f4c46;
  border-color: #5eead4;
}

.staking-payout-status-pill--cancelled {
  background: #ffedd5;
  color: #9a3412;
  border-color: #fdba74;
}

.staking-payout-cancel-card {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border: 1px solid #fed7aa;
  border-radius: 14px;
  padding: 1rem 1.1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(154, 52, 18, 0.08);
}

.staking-payout-cancel-card__title {
  margin: 0 0 0.75rem;
  font-size: 0.82rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9a3412;
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.staking-payout-cancel-card__title i {
  font-size: 0.9rem;
  opacity: 0.95;
}

.staking-payout-cancel-card__dl {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 1rem;
}

@media (max-width: 520px) {
  .staking-payout-cancel-card__dl {
    grid-template-columns: 1fr;
  }
}

.staking-payout-cancel-card__dl > div {
  margin: 0;
}

.staking-payout-cancel-card__dl dt {
  margin: 0 0 0.15rem;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #c2410c;
  opacity: 0.9;
}

.staking-payout-cancel-card__dl dd {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 700;
  color: #431407;
  line-height: 1.35;
  word-break: break-word;
}

/* Stat grid */
.staking-payout-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

@media (max-width: 640px) {
  .staking-payout-stat-grid {
    grid-template-columns: 1fr;
  }
}

.staking-payout-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.75rem 0.85rem;
  min-height: 4.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s, border-color 0.2s;
}

.staking-payout-stat:hover {
  border-color: #5eead4;
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.1);
}

.staking-payout-stat__icon {
  color: #0f766e;
  font-size: 0.85rem;
  opacity: 0.9;
  margin-bottom: 0.05rem;
}

.staking-payout-stat__label {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #64748b;
}

.staking-payout-stat__value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  word-break: break-word;
}

.staking-payout-stat__hint {
  font-weight: 500;
  color: #94a3b8;
  font-size: 0.8rem;
  margin-left: 0.2rem;
}

/* Timeline row */
.staking-payout-timeline {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
  margin-bottom: 1.1rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.85rem 1rem;
  font-size: 0.8rem;
}

@media (max-width: 560px) {
  .staking-payout-timeline {
    grid-template-columns: 1fr;
  }
}

.staking-payout-timeline__l {
  display: block;
  color: #64748b;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.2rem;
}

.staking-payout-timeline__v {
  color: #0f172a;
  font-weight: 600;
}

/* Log card */
.staking-payout-log-card {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.staking-payout-log-card__head {
  padding: 1rem 1.2rem 0.6rem;
  background: linear-gradient(180deg, #fff 0%, #ecfdf5 100%);
  border-bottom: 1px solid #d1fae5;
}

.staking-payout-log-card__head h3 {
  margin: 0 0 0.2rem;
  font-size: 1rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.staking-payout-log-card__head p {
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.45;
}

.staking-payout-periods-card {
  margin-top: 1rem;
}

.staking-payout-periods-card .stake-report-kv-grid {
  padding: 0.75rem 1.2rem 0;
}

.staking-payout-periods-card .stake-report-table-wrap {
  padding: 0.75rem 1.2rem 1rem;
}

.staking-payout-periods-card .openorders-empty {
  padding: 0.75rem 1.2rem 1rem;
  margin: 0;
}

.staking-payout-table-wrap {
  overflow-x: auto;
}

.staking-payout-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.staking-payout-table th,
.staking-payout-table td {
  padding: 0.65rem 1rem;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
}

.staking-payout-table th {
  background: #f0fdfa;
  font-weight: 700;
  color: #0f4c46;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #ccfbf1;
}

.staking-payout-table tbody tr {
  background: #fff;
}

.staking-payout-table tbody tr:hover {
  background: #f0fdfa;
}

.staking-payout-table tbody tr:last-child td {
  border-bottom: none;
}

.staking-payout-day-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.75rem;
  padding: 0.2rem 0.45rem;
  border-radius: 6px;
  background: #ccfbf1;
  color: #0f4c46;
  font-weight: 800;
  font-size: 0.82rem;
  font-variant-numeric: tabular-nums;
  border: 1px solid #99f6e4;
}

.staking-payout-table__amount {
  font-weight: 700;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.staking-payout-table__ccy {
  font-weight: 600;
  color: #64748b;
  font-size: 0.82em;
  margin-left: 0.15rem;
}

.staking-payout-table-wrap--empty {
  padding: 1.5rem 1.25rem;
  text-align: center;
  color: #64748b;
  font-size: 0.88rem;
  border-top: 1px solid #f1f5f9;
}

/* —— History button —— */
.staking-stakes__history-btn {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid rgba(99, 102, 241, 0.4);
  background: #f5f3ff;
  color: #4f46e5;
  transition: background 0.2s, border-color 0.2s;
}

.staking-stakes__history-btn:hover:not(:disabled) {
  background: #ede9fe;
  border-color: #6366f1;
}

.staking-stakes__history-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* —— Edit history modal —— */
.staking-edit-history-modal {
  background: #fff;
  border-radius: 18px;
  max-width: 640px;
  width: 100%;
  max-height: 92vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(99, 102, 241, 0.15);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.staking-edit-history-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.35rem 1.5rem 1.2rem;
  background: linear-gradient(125deg, #4338ca 0%, #6366f1 42%, #3730a3 100%);
  color: #fff;
  gap: 1rem;
  flex-shrink: 0;
}

.staking-edit-history-modal__head h2 {
  margin: 0 0 0.25rem;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #fff;
}

.staking-edit-history-modal__body {
  min-height: 0;
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem 1.35rem;
  background: linear-gradient(180deg, #eef2ff 0%, #f8fafc 28%, #f8fafc 100%);
}

.staking-edit-history-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #94a3b8;
}

.staking-edit-history-empty i {
  font-size: 2rem;
  margin-bottom: 0.75rem;
  display: block;
  opacity: 0.45;
}

.staking-edit-history-empty p {
  margin: 0;
  font-size: 0.9rem;
}

.staking-edit-history-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.staking-edit-history-entry {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.staking-edit-history-entry__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  background: linear-gradient(180deg, #eef2ff 0%, #f5f3ff 100%);
  border-bottom: 1px solid #e0e7ff;
}

.staking-edit-history-entry__meta {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.staking-edit-history-entry__index {
  font-size: 0.7rem;
  font-weight: 800;
  background: #4f46e5;
  color: #fff;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  letter-spacing: 0.03em;
}

.staking-edit-history-entry__date {
  font-size: 0.78rem;
  color: #4b5563;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.staking-edit-history-entry__date i {
  color: #6366f1;
  font-size: 0.72rem;
}

.staking-edit-history-entry__admin {
  font-size: 0.78rem;
  color: #374151;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.staking-edit-history-entry__admin i {
  color: #4f46e5;
  font-size: 0.8rem;
}

.staking-edit-history-entry__admin-type {
  font-size: 0.65rem;
  font-weight: 700;
  background: #e0e7ff;
  color: #3730a3;
  padding: 0.1rem 0.4rem;
  border-radius: 6px;
  letter-spacing: 0.04em;
}

.staking-edit-history-entry__body {
  padding: 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.staking-edit-history-changes {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.staking-edit-history-change {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.84rem;
}

.staking-edit-history-change__field {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: capitalize;
  letter-spacing: 0.04em;
  color: #6366f1;
  background: #eef2ff;
  padding: 0.15rem 0.5rem;
  border-radius: 6px;
  min-width: 7rem;
  text-align: center;
}

.staking-edit-history-change__from {
  font-weight: 700;
  color: #b91c1c;
  font-variant-numeric: tabular-nums;
  text-decoration: line-through;
  opacity: 0.8;
}

.staking-edit-history-change__arrow {
  color: #94a3b8;
  font-size: 0.7rem;
}

.staking-edit-history-change__to {
  font-weight: 700;
  color: #047857;
  font-variant-numeric: tabular-nums;
}

.staking-edit-history-status-change {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.staking-edit-history-entry__notes {
  margin: 0;
  font-size: 0.83rem;
  color: #475569;
  line-height: 1.5;
  padding: 0.5rem 0.65rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  display: flex;
  gap: 0.4rem;
  align-items: flex-start;
  white-space: pre-wrap;
  word-break: break-word;
}

.staking-edit-history-entry__notes i {
  color: #6366f1;
  font-size: 0.8rem;
  margin-top: 0.1rem;
  flex-shrink: 0;
}

/* Footer */
.staking-payout-modal__foot {
  padding: 1rem 1.5rem 1.25rem;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.04);
  display: flex;
  justify-content: flex-end;
}

.staking-payout-btn-close {
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.6rem 1.35rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.staking-payout-btn-close:hover {
  background: #f0fdfa;
  border-color: #99f6e4;
  color: #0f766e;
}

/* —— ZILN converter inside edit modal —— */
.staking-edit-zil-convert {
  margin-top: 0.85rem;
  border: 1px solid #e0e7ff;
  border-radius: 12px;
  background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
  padding: 0.9rem 1rem;
}

.staking-edit-zil-convert__title {
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4338ca;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.3rem;
}

.staking-edit-zil-convert__title i {
  font-size: 0.8rem;
}

.staking-edit-zil-convert__sub {
  margin: 0 0 0.75rem;
  font-size: 0.76rem;
  color: #6366f1;
  line-height: 1.45;
}

.staking-edit-zil-convert__row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}

.staking-edit-zil-convert__input {
  flex: 1 1;
  padding: 0.5rem 0.65rem;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  font-size: 0.88rem;
  font-family: inherit;
  color: #1e1b4b;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.staking-edit-zil-convert__input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.staking-edit-zil-convert__input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.staking-edit-zil-convert__btn {
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 0.5rem 0.9rem;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #4338ca 0%, #6366f1 100%);
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: opacity 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.3);
}

.staking-edit-zil-convert__btn:hover:not(:disabled) {
  opacity: 0.92;
  box-shadow: 0 3px 10px rgba(99, 102, 241, 0.4);
}

.staking-edit-zil-convert__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.staking-edit-zil-convert__error {
  margin: 0.5rem 0 0;
  font-size: 0.78rem;
  color: #b91c1c;
  font-weight: 600;
}

.staking-edit-zil-convert__result {
  margin-top: 0.75rem;
  background: #fff;
  border: 1px solid #a5b4fc;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.staking-edit-zil-convert__result-amounts {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-variant-numeric: tabular-nums;
}

.staking-edit-zil-convert__from {
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  text-decoration: line-through;
  opacity: 0.8;
}

.staking-edit-zil-convert__arrow {
  color: #a5b4fc;
  font-size: 0.75rem;
}

.staking-edit-zil-convert__to {
  font-size: 0.95rem;
  font-weight: 800;
  color: #3730a3;
}

.staking-edit-zil-convert__apply {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.35rem 0.8rem;
  border-radius: 7px;
  border: 1px solid #a5b4fc;
  background: #eef2ff;
  color: #4338ca;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  transition: background 0.2s, border-color 0.2s;
}

.staking-edit-zil-convert__apply:hover {
  background: #e0e7ff;
  border-color: #818cf8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Staking/StakingStakesPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,+DAA+D;EAC/D,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,0DAA0D;EAC1D,cAAc;EACd,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uFAAuF;EACvF,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0EAA0E;EAC1E,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,iCAAiC;EACjC,4BAA4B;EAC5B,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;AACF;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EAEb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uFAAuF;EACvF,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,0EAA0E;EAC1E,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;EACnD,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0DAA0D;EAC1D,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uFAAuF;EACvF,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,0EAA0E;EAC1E,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,wBAAwB;EACxB,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".staking-stakes__header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.staking-stakes__export-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);\n  color: #166534;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.staking-stakes__export-btn:hover:not(:disabled) {\n  background: #dcfce7;\n  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);\n}\n\n.staking-stakes__export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.staking-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted, #64748b);\n  flex: 0 1 120px;\n}\n\n.staking-page-limit__select {\n  max-width: none;\n  margin: 0;\n  min-width: 100px;\n}\n\n/* —— User Stakes: View button (teal / green theme) —— */\n.staking-stakes__view-btn {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.4rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 118, 110, 0.45);\n  background: linear-gradient(180deg, #fff 0%, #f0fdfa 100%);\n  color: #0f766e;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.12);\n  transition: background 0.2s, box-shadow 0.2s, border-color 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.staking-stakes__view-btn:hover:not(:disabled) {\n  background: #ccfbf1;\n  border-color: #0d9488;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.2);\n}\n\n.staking-stakes__view-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.staking-stakes__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.staking-stakes__payout-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  align-items: stretch;\n  width: 100%;\n}\n\n.staking-stakes__payout-btn--plan {\n  font-size: 0.72rem;\n}\n\n.staking-stakes__payout-badge {\n  display: inline-block;\n  padding: 0.25rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.staking-stakes__payout-badge--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.staking-stakes__payout-badge--inactive {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.staking-stakes__payout-btn {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.staking-stakes__payout-btn--on {\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.staking-stakes__payout-btn--on:hover:not(:disabled) {\n  background: #dcfce7;\n}\n\n.staking-stakes__payout-btn--off {\n  border: 1px solid rgba(185, 28, 28, 0.35);\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.staking-stakes__payout-btn--off:hover:not(:disabled) {\n  background: #fee2e2;\n}\n\n.staking-stakes__payout-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.staking-stakes__cancel-btn {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border: 1px solid rgba(154, 52, 18, 0.4);\n  background: #fff7ed;\n  color: #9a3412;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.staking-stakes__cancel-btn:hover:not(:disabled) {\n  background: #ffedd5;\n  border-color: #ea580c;\n}\n\n.staking-stakes__cancel-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.staking-stakes__edit-btn {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border: 1px solid rgba(15, 118, 110, 0.45);\n  background: linear-gradient(180deg, #fff 0%, #f0fdfa 100%);\n  color: #0f766e;\n  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.staking-stakes__edit-btn:hover:not(:disabled) {\n  background: #ccfbf1;\n  border-color: #0d9488;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.15);\n}\n\n.staking-stakes__edit-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.staking-stakes__edit-btn--submit {\n  padding: 0.55rem 1.25rem;\n  font-size: 0.88rem;\n  border: none;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);\n}\n\n.staking-stakes__edit-btn--submit:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n  border-color: transparent;\n  opacity: 0.95;\n}\n\n/* —— Edit subscription modal —— */\n.staking-edit-modal {\n  background: #fff;\n  border-radius: 18px;\n  max-width: 520px;\n  width: 100%;\n  max-height: min(92vh, calc(100dvh - 2rem));\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(15, 118, 110, 0.15);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n}\n\n.staking-edit-modal__form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.staking-edit-modal__head {\n  padding: 1.25rem 1.35rem 1rem;\n  background: linear-gradient(125deg, #0f766e 0%, #0d9488 42%, #0f4c46 100%);\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.staking-edit-modal__head h2 {\n  margin: 0 0 0.35rem;\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\n.staking-edit-modal__head p {\n  margin: 0;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.45;\n}\n\n.staking-edit-modal__hint {\n  margin: 0.5rem 0 0 !important;\n  font-size: 0.75rem !important;\n  color: rgba(255, 255, 255, 0.72) !important;\n  font-style: italic;\n}\n\n.staking-edit-modal__body {\n  padding: 1.15rem 1.35rem;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  background: linear-gradient(180deg, #ecfdf5 0%, #f8fafc 28%, #f8fafc 100%);\n}\n\n.staking-edit-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.75rem;\n}\n\n.staking-edit-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.staking-edit-field--full {\n  grid-column: 1 / -1;\n}\n\n.staking-edit-field span {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #0f766e;\n}\n\n.staking-edit-field input,\n.staking-edit-field select,\n.staking-edit-field textarea {\n  width: 100%;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  font-family: inherit;\n  color: #0f172a;\n  background: #fff;\n  box-sizing: border-box;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.staking-edit-field input:focus,\n.staking-edit-field select:focus,\n.staking-edit-field textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.12);\n}\n\n.staking-edit-field--readonly span {\n  color: #94a3b8;\n}\n\n.staking-edit-field--readonly input:disabled,\n.staking-edit-field--readonly select:disabled,\n.staking-edit-field--readonly textarea:disabled {\n  background: #f1f5f9;\n  color: #64748b;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.staking-edit-field textarea {\n  resize: vertical;\n  min-height: 4.5rem;\n}\n\n.staking-edit-modal__id {\n  margin: 0.85rem 0 0;\n  font-size: 0.72rem;\n  color: #64748b;\n}\n\n.staking-edit-modal__id code {\n  font-size: 0.7rem;\n  word-break: break-all;\n  color: #334155;\n}\n\n.staking-edit-modal__error {\n  margin: 0.75rem 0 0;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  background: rgba(220, 38, 38, 0.08);\n  color: #b91c1c;\n  font-size: 0.85rem;\n}\n\n.staking-edit-modal__foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 1rem 1.35rem 1.25rem;\n  flex-shrink: 0;\n  border-top: 1px solid #d1fae5;\n  background: #fff;\n  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.04);\n}\n\n.staking-edit-modal__foot .staking-payout-btn-close:hover:not(:disabled) {\n  background: #f0fdfa;\n  border-color: #99f6e4;\n  color: #0f766e;\n}\n\n@media (max-width: 480px) {\n  .staking-edit-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .staking-payout-overlay {\n    align-items: flex-start;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding: 0.75rem;\n  }\n\n  .staking-edit-modal {\n    max-height: none;\n    margin: auto 0;\n    flex-shrink: 0;\n  }\n}\n\n/* —— Cancel plan confirm / success —— */\n.staking-cancel-modal {\n  background: #fff;\n  border-radius: 16px;\n  max-width: 440px;\n  width: 100%;\n  overflow: hidden;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.35);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n}\n\n.staking-cancel-modal__head {\n  padding: 1.25rem 1.35rem 1rem;\n  background: linear-gradient(125deg, #9a3412 0%, #c2410c 55%, #7c2d12 100%);\n  color: #fff;\n}\n\n.staking-cancel-modal__head h2 {\n  margin: 0 0 0.35rem;\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n.staking-cancel-modal__head p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.45;\n}\n\n.staking-cancel-modal__body {\n  padding: 1.15rem 1.35rem;\n}\n\n.staking-cancel-modal__summary {\n  margin: 0 0 1rem;\n  padding: 0.75rem 0.9rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: #334155;\n}\n\n.staking-cancel-modal__summary strong {\n  color: #0f172a;\n}\n\n.staking-cancel-modal__warn {\n  margin: 0;\n  font-size: 0.82rem;\n  color: #b45309;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  line-height: 1.45;\n}\n\n.staking-cancel-modal__foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0 1.35rem 1.25rem;\n}\n\n.staking-cancel-success__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n  margin: 0 0 1rem;\n}\n\n.staking-cancel-success__item {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 10px;\n  padding: 0.65rem 0.75rem;\n}\n\n.staking-cancel-success__item dt {\n  margin: 0 0 0.2rem;\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #166534;\n}\n\n.staking-cancel-success__item dd {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #14532d;\n  word-break: break-word;\n}\n\n.staking-cancel-success__item--refund {\n  grid-column: 1 / -1;\n  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);\n  border-color: #6ee7b7;\n}\n\n.staking-cancel-success__item--refund dd {\n  font-size: 1.05rem;\n  color: #047857;\n}\n\n/* —— Premium Payout history modal —— */\n.staking-payout-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  -webkit-backdrop-filter: blur(5px);\n  backdrop-filter: blur(5px);\n}\n\n.staking-payout-modal {\n  background: #fff;\n  border-radius: 18px;\n  max-width: 680px;\n  width: 100%;\n  max-height: 92vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(15, 118, 110, 0.15);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n}\n\n.staking-payout-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.35rem 1.5rem 1.2rem;\n  background: linear-gradient(125deg, #0f766e 0%, #0d9488 42%, #0f4c46 100%);\n  color: #fff;\n  gap: 1rem;\n}\n\n.staking-payout-head-eyebrow {\n  margin: 0 0 0.2rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  opacity: 0.88;\n}\n\n.staking-payout-modal__head h2 {\n  margin: 0 0 0.25rem;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #fff;\n}\n\n.staking-payout-head-sub {\n  margin: 0;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.78);\n  line-height: 1.4;\n  max-width: 28rem;\n}\n\n.staking-payout-modal__close {\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.staking-payout-modal__close:hover {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.staking-payout-modal__body {\n  min-height: 0;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.staking-payout-modal__body--premium {\n  padding: 1.5rem 1.5rem 1.25rem;\n  background: linear-gradient(180deg, #ecfdf5 0%, #f8fafc 32%, #f8fafc 100%);\n}\n\n.staking-payout-loading {\n  text-align: center;\n  padding: 2.5rem 1.5rem;\n  color: #64748b;\n  font-size: 0.92rem;\n}\n\n.staking-payout-loading__ring {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border: 3px solid #ccfbf1;\n  border-top-color: #0f766e;\n  border-radius: 50%;\n  animation: staking-payout-spin 0.7s linear infinite;\n  margin-bottom: 0.75rem;\n  vertical-align: middle;\n}\n\n@keyframes staking-payout-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.staking-payout-alert {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n/* Hero */\n.staking-payout-hero {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1.2rem 1.35rem;\n  margin-bottom: 1rem;\n  border: 1px solid rgba(226, 232, 240, 0.95);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(15, 118, 110, 0.08);\n}\n\n.staking-payout-hero__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.staking-payout-hero__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #64748b;\n}\n\n.staking-payout-hero__title {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n}\n\n.staking-payout-hero__sub {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.staking-payout-hero__wallets {\n  margin: 0.85rem 0 0;\n  font-size: 0.86rem;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.staking-payout-hero__wallets i {\n  color: #0f766e;\n  width: 1.1rem;\n  text-align: center;\n}\n\n.staking-payout-hero__arrow {\n  color: #94a3b8;\n  font-weight: 600;\n  padding: 0 0.1rem;\n}\n\n.staking-payout-notes-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.9rem 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.staking-payout-notes-card__title {\n  margin: 0 0 0.5rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.staking-payout-notes-card__title i {\n  color: #0f766e;\n}\n\n.staking-payout-notes-card__text {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: #334155;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.staking-payout-status-pill {\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.35rem 0.7rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  flex-shrink: 0;\n}\n\n.staking-payout-status-pill--on {\n  background: #d1fae5;\n  color: #047857;\n  border-color: #a7f3d0;\n}\n\n.staking-payout-status-pill--off {\n  background: #f1f5f9;\n  color: #64748b;\n  border-color: #e2e8f0;\n}\n\n.staking-payout-status-pill--done {\n  background: #ccfbf1;\n  color: #0f4c46;\n  border-color: #5eead4;\n}\n\n.staking-payout-status-pill--cancelled {\n  background: #ffedd5;\n  color: #9a3412;\n  border-color: #fdba74;\n}\n\n.staking-payout-cancel-card {\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);\n  border: 1px solid #fed7aa;\n  border-radius: 14px;\n  padding: 1rem 1.1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 8px rgba(154, 52, 18, 0.08);\n}\n\n.staking-payout-cancel-card__title {\n  margin: 0 0 0.75rem;\n  font-size: 0.82rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #9a3412;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.staking-payout-cancel-card__title i {\n  font-size: 0.9rem;\n  opacity: 0.95;\n}\n\n.staking-payout-cancel-card__dl {\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem 1rem;\n}\n\n@media (max-width: 520px) {\n  .staking-payout-cancel-card__dl {\n    grid-template-columns: 1fr;\n  }\n}\n\n.staking-payout-cancel-card__dl > div {\n  margin: 0;\n}\n\n.staking-payout-cancel-card__dl dt {\n  margin: 0 0 0.15rem;\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #c2410c;\n  opacity: 0.9;\n}\n\n.staking-payout-cancel-card__dl dd {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #431407;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n/* Stat grid */\n.staking-payout-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 640px) {\n  .staking-payout-stat-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.staking-payout-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.75rem 0.85rem;\n  min-height: 4.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s, border-color 0.2s;\n}\n\n.staking-payout-stat:hover {\n  border-color: #5eead4;\n  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.1);\n}\n\n.staking-payout-stat__icon {\n  color: #0f766e;\n  font-size: 0.85rem;\n  opacity: 0.9;\n  margin-bottom: 0.05rem;\n}\n\n.staking-payout-stat__label {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #64748b;\n}\n\n.staking-payout-stat__value {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.staking-payout-stat__hint {\n  font-weight: 500;\n  color: #94a3b8;\n  font-size: 0.8rem;\n  margin-left: 0.2rem;\n}\n\n/* Timeline row */\n.staking-payout-timeline {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.65rem;\n  margin-bottom: 1.1rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.85rem 1rem;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 560px) {\n  .staking-payout-timeline {\n    grid-template-columns: 1fr;\n  }\n}\n\n.staking-payout-timeline__l {\n  display: block;\n  color: #64748b;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.2rem;\n}\n\n.staking-payout-timeline__v {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n/* Log card */\n.staking-payout-log-card {\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.staking-payout-log-card__head {\n  padding: 1rem 1.2rem 0.6rem;\n  background: linear-gradient(180deg, #fff 0%, #ecfdf5 100%);\n  border-bottom: 1px solid #d1fae5;\n}\n\n.staking-payout-log-card__head h3 {\n  margin: 0 0 0.2rem;\n  font-size: 1rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.staking-payout-log-card__head p {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.staking-payout-periods-card {\n  margin-top: 1rem;\n}\n\n.staking-payout-periods-card .stake-report-kv-grid {\n  padding: 0.75rem 1.2rem 0;\n}\n\n.staking-payout-periods-card .stake-report-table-wrap {\n  padding: 0.75rem 1.2rem 1rem;\n}\n\n.staking-payout-periods-card .openorders-empty {\n  padding: 0.75rem 1.2rem 1rem;\n  margin: 0;\n}\n\n.staking-payout-table-wrap {\n  overflow-x: auto;\n}\n\n.staking-payout-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.staking-payout-table th,\n.staking-payout-table td {\n  padding: 0.65rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.staking-payout-table th {\n  background: #f0fdfa;\n  font-weight: 700;\n  color: #0f4c46;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid #ccfbf1;\n}\n\n.staking-payout-table tbody tr {\n  background: #fff;\n}\n\n.staking-payout-table tbody tr:hover {\n  background: #f0fdfa;\n}\n\n.staking-payout-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.staking-payout-day-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.75rem;\n  padding: 0.2rem 0.45rem;\n  border-radius: 6px;\n  background: #ccfbf1;\n  color: #0f4c46;\n  font-weight: 800;\n  font-size: 0.82rem;\n  font-variant-numeric: tabular-nums;\n  border: 1px solid #99f6e4;\n}\n\n.staking-payout-table__amount {\n  font-weight: 700;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.staking-payout-table__ccy {\n  font-weight: 600;\n  color: #64748b;\n  font-size: 0.82em;\n  margin-left: 0.15rem;\n}\n\n.staking-payout-table-wrap--empty {\n  padding: 1.5rem 1.25rem;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.88rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n/* —— History button —— */\n.staking-stakes__history-btn {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border: 1px solid rgba(99, 102, 241, 0.4);\n  background: #f5f3ff;\n  color: #4f46e5;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.staking-stakes__history-btn:hover:not(:disabled) {\n  background: #ede9fe;\n  border-color: #6366f1;\n}\n\n.staking-stakes__history-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* —— Edit history modal —— */\n.staking-edit-history-modal {\n  background: #fff;\n  border-radius: 18px;\n  max-width: 640px;\n  width: 100%;\n  max-height: 92vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(99, 102, 241, 0.15);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n}\n\n.staking-edit-history-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.35rem 1.5rem 1.2rem;\n  background: linear-gradient(125deg, #4338ca 0%, #6366f1 42%, #3730a3 100%);\n  color: #fff;\n  gap: 1rem;\n  flex-shrink: 0;\n}\n\n.staking-edit-history-modal__head h2 {\n  margin: 0 0 0.25rem;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #fff;\n}\n\n.staking-edit-history-modal__body {\n  min-height: 0;\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem 1.35rem;\n  background: linear-gradient(180deg, #eef2ff 0%, #f8fafc 28%, #f8fafc 100%);\n}\n\n.staking-edit-history-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #94a3b8;\n}\n\n.staking-edit-history-empty i {\n  font-size: 2rem;\n  margin-bottom: 0.75rem;\n  display: block;\n  opacity: 0.45;\n}\n\n.staking-edit-history-empty p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.staking-edit-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.staking-edit-history-entry {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.staking-edit-history-entry__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.65rem 1rem;\n  background: linear-gradient(180deg, #eef2ff 0%, #f5f3ff 100%);\n  border-bottom: 1px solid #e0e7ff;\n}\n\n.staking-edit-history-entry__meta {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.staking-edit-history-entry__index {\n  font-size: 0.7rem;\n  font-weight: 800;\n  background: #4f46e5;\n  color: #fff;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  letter-spacing: 0.03em;\n}\n\n.staking-edit-history-entry__date {\n  font-size: 0.78rem;\n  color: #4b5563;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.staking-edit-history-entry__date i {\n  color: #6366f1;\n  font-size: 0.72rem;\n}\n\n.staking-edit-history-entry__admin {\n  font-size: 0.78rem;\n  color: #374151;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.staking-edit-history-entry__admin i {\n  color: #4f46e5;\n  font-size: 0.8rem;\n}\n\n.staking-edit-history-entry__admin-type {\n  font-size: 0.65rem;\n  font-weight: 700;\n  background: #e0e7ff;\n  color: #3730a3;\n  padding: 0.1rem 0.4rem;\n  border-radius: 6px;\n  letter-spacing: 0.04em;\n}\n\n.staking-edit-history-entry__body {\n  padding: 0.85rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.staking-edit-history-changes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.staking-edit-history-change {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-size: 0.84rem;\n}\n\n.staking-edit-history-change__field {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  letter-spacing: 0.04em;\n  color: #6366f1;\n  background: #eef2ff;\n  padding: 0.15rem 0.5rem;\n  border-radius: 6px;\n  min-width: 7rem;\n  text-align: center;\n}\n\n.staking-edit-history-change__from {\n  font-weight: 700;\n  color: #b91c1c;\n  font-variant-numeric: tabular-nums;\n  text-decoration: line-through;\n  opacity: 0.8;\n}\n\n.staking-edit-history-change__arrow {\n  color: #94a3b8;\n  font-size: 0.7rem;\n}\n\n.staking-edit-history-change__to {\n  font-weight: 700;\n  color: #047857;\n  font-variant-numeric: tabular-nums;\n}\n\n.staking-edit-history-status-change {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.staking-edit-history-entry__notes {\n  margin: 0;\n  font-size: 0.83rem;\n  color: #475569;\n  line-height: 1.5;\n  padding: 0.5rem 0.65rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  gap: 0.4rem;\n  align-items: flex-start;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.staking-edit-history-entry__notes i {\n  color: #6366f1;\n  font-size: 0.8rem;\n  margin-top: 0.1rem;\n  flex-shrink: 0;\n}\n\n/* Footer */\n.staking-payout-modal__foot {\n  padding: 1rem 1.5rem 1.25rem;\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.04);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.staking-payout-btn-close {\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 0.6rem 1.35rem;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.staking-payout-btn-close:hover {\n  background: #f0fdfa;\n  border-color: #99f6e4;\n  color: #0f766e;\n}\n\n/* —— ZILN converter inside edit modal —— */\n.staking-edit-zil-convert {\n  margin-top: 0.85rem;\n  border: 1px solid #e0e7ff;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);\n  padding: 0.9rem 1rem;\n}\n\n.staking-edit-zil-convert__title {\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #4338ca;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.3rem;\n}\n\n.staking-edit-zil-convert__title i {\n  font-size: 0.8rem;\n}\n\n.staking-edit-zil-convert__sub {\n  margin: 0 0 0.75rem;\n  font-size: 0.76rem;\n  color: #6366f1;\n  line-height: 1.45;\n}\n\n.staking-edit-zil-convert__row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.staking-edit-zil-convert__input {\n  flex: 1;\n  padding: 0.5rem 0.65rem;\n  border: 1px solid #c7d2fe;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  font-family: inherit;\n  color: #1e1b4b;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.staking-edit-zil-convert__input:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.staking-edit-zil-convert__input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.staking-edit-zil-convert__btn {\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  padding: 0.5rem 0.9rem;\n  border-radius: 8px;\n  border: none;\n  background: linear-gradient(135deg, #4338ca 0%, #6366f1 100%);\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  transition: opacity 0.2s, box-shadow 0.2s;\n  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.3);\n}\n\n.staking-edit-zil-convert__btn:hover:not(:disabled) {\n  opacity: 0.92;\n  box-shadow: 0 3px 10px rgba(99, 102, 241, 0.4);\n}\n\n.staking-edit-zil-convert__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.staking-edit-zil-convert__error {\n  margin: 0.5rem 0 0;\n  font-size: 0.78rem;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.staking-edit-zil-convert__result {\n  margin-top: 0.75rem;\n  background: #fff;\n  border: 1px solid #a5b4fc;\n  border-radius: 10px;\n  padding: 0.65rem 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.staking-edit-zil-convert__result-amounts {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.staking-edit-zil-convert__from {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #64748b;\n  text-decoration: line-through;\n  opacity: 0.8;\n}\n\n.staking-edit-zil-convert__arrow {\n  color: #a5b4fc;\n  font-size: 0.75rem;\n}\n\n.staking-edit-zil-convert__to {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: #3730a3;\n}\n\n.staking-edit-zil-convert__apply {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.35rem 0.8rem;\n  border-radius: 7px;\n  border: 1px solid #a5b4fc;\n  background: #eef2ff;\n  color: #4338ca;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.staking-edit-zil-convert__apply:hover {\n  background: #e0e7ff;\n  border-color: #818cf8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
